const svg = {
  profileSm: () => (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="24" r="24" fill="#0E79B7" />
      <circle cx="23.625" cy="15.375" r="8.625" fill="white" />
      <ellipse cx="24" cy="34.5" rx="14.25" ry="7.5" fill="white" />
      <path
        d="M23.625 6.75C21.3375 6.75 19.1437 7.6587 17.5262 9.2762C15.9087 10.8937 15 13.0875 15 15.375C15 17.6625 15.9087 19.8563 17.5262 21.4738C19.1437 23.0913 21.3375 24 23.625 24L23.625 15.375V6.75Z"
        fill="#CFE4F1"
      />
      <path
        d="M24 42C20.2207 42 16.5961 41.2098 13.9237 39.8033C11.2513 38.3968 9.75 36.4891 9.75 34.5C9.75 32.5109 11.2513 30.6032 13.9237 29.1967C16.5961 27.7902 20.2207 27 24 27V34.5L24 42Z"
        fill="#CFE4F1"
      />
    </svg>
  ),
  folder: () => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4535_2505)">
        <path
          d="M20 5.99997H12L10 3.99997H4C2.9 3.99997 2.01 4.89997 2.01 5.99997L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V7.99997C22 6.89997 21.1 5.99997 20 5.99997ZM20 18H4V7.99997H20V18Z"
          fill="#4CAF50"
        />
      </g>
      <defs>
        <clipPath id="clip0_4535_2505">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  trending: () => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4535_4804)">
        <path
          d="M16 5.99997L18.29 8.28997L13.41 13.17L9.41 9.16997L2 16.59L3.41 18L9.41 12L13.41 16L19.71 9.70997L22 12V5.99997H16Z"
          fill="#4CAF50"
        />
      </g>
      <defs>
        <clipPath id="clip0_4535_4804">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  scale: () => (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 9H0V14H5V12H2V9ZM0 5H2V2H5V0H0V5ZM12 12H9V14H14V9H12V12ZM9 0V2H12V5H14V0H9Z"
        fill="#0E79B7"
      />
    </svg>
  ),
  plus: () => (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.8 6.79999H6.80002V10.8C6.80002 11.24 6.44002 11.6 6.00002 11.6C5.56002 11.6 5.20002 11.24 5.20002 10.8V6.79999H1.20002C0.760024 6.79999 0.400024 6.43999 0.400024 5.99999C0.400024 5.55999 0.760024 5.19999 1.20002 5.19999H5.20002V1.19999C5.20002 0.759994 5.56002 0.399994 6.00002 0.399994C6.44002 0.399994 6.80002 0.759994 6.80002 1.19999V5.19999H10.8C11.24 5.19999 11.6 5.55999 11.6 5.99999C11.6 6.43999 11.24 6.79999 10.8 6.79999Z"
        fill="#0E79B7"
      />
    </svg>
  ),
  minus: () => (
    <svg
      width="12"
      height="2"
      viewBox="0 0 12 2"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M11.6 1.79998H0.400024V0.199982H11.6V1.79998Z" fill="#0E79B7" />
    </svg>
  ),
  pin: () => (
    <svg
      width="36"
      height="44"
      viewBox="0 0 36 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_4535_5667)">
        <path
          d="M18 4.66667C12.84 4.66667 8.66669 8.84001 8.66669 14C8.66669 21 18 31.3333 18 31.3333C18 31.3333 27.3334 21 27.3334 14C27.3334 8.84001 23.16 4.66667 18 4.66667ZM18 17.3333C16.16 17.3333 14.6667 15.84 14.6667 14C14.6667 12.16 16.16 10.6667 18 10.6667C19.84 10.6667 21.3334 12.16 21.3334 14C21.3334 15.84 19.84 17.3333 18 17.3333Z"
          fill="#F7941D"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_4535_5667"
          x="0.666687"
          y="0.666672"
          width="34.6667"
          height="42.6667"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="4" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4535_5667"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4535_5667"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  ),
  eye: () => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" fill="white" fillOpacity="0.01" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 18C7.464 18 4.001 13.74 4.001 12C4.001 9.999 7.46 6 12.001 6C16.377 6 19.999 9.973 19.999 12C19.999 13.74 16.537 18 12.001 18H12ZM12.001 4C6.48 4 2 8.841 2 12C2 15.086 6.576 20 12 20C17.423 20 22 15.086 22 12C22 8.841 17.52 4 12 4"
        fill="#0052CC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.977 13.984C10.874 13.984 9.977 13.087 9.977 11.984C9.977 10.881 10.874 9.984 11.977 9.984C13.081 9.984 13.977 10.881 13.977 11.984C13.977 13.087 13.081 13.984 11.977 13.984ZM11.977 7.984C9.771 7.984 7.977 9.778 7.977 11.984C7.977 14.19 9.771 15.984 11.977 15.984C14.184 15.984 15.977 14.19 15.977 11.984C15.977 9.778 14.184 7.984 11.977 7.984Z"
        fill="#0052CC"
      />
    </svg>
  ),
  send: () => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4603_16413)">
        <path
          d="M1.67435 17.5L19.166 10L1.67435 2.5L1.66602 8.33333L14.166 10L1.66602 11.6667L1.67435 17.5Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_4603_16413">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
};

export default svg;
